import "./VopPage.scss";
import React from "react";
import { Link } from "react-router-dom";

const TermsAndConditions = () => {
  return (
    <div className="vop-page">
      <article className="vop-page__article">
        <h1>Všeobecné podmienky</h1>
        <h2>
          používania webu triferis.sk a dopytového formulára Penziónu Triferis
        </h2>

        <p>
          Tieto podmienky upravujú používanie webu triferis.sk a posielanie
          dopytov na pobyt v Penzióne Triferis. Web slúži na informovanie o
          penzióne a na nezáväzný dopyt. Pobyt sa cez web nedá rezervovať ani
          zaplatiť.
        </p>

        <h2>Článok I. Prevádzkovateľ</h2>
        <ul>
          <li>
            <strong>Obchodné meno:</strong> Táborčatá s. r. o.
          </li>
          <li>
            <strong>Sídlo:</strong> Budatínska 3230/16A, 851 06 Bratislava –
            mestská časť Petržalka
          </li>
          <li>
            <strong>IČO:</strong> 56 040 890
          </li>
          <li>
            <strong>Zápis:</strong> Obchodný register Mestského súdu Bratislava
            III, oddiel Sro, vložka č. 177035/B
          </li>
          <li>
            <strong>Prevádzka:</strong> Penzión Triferis, Bystrá 118, 977 01
            Bystrá
          </li>
          <li>
            <strong>E-mail:</strong>{" "}
            <a href="mailto:info@triferis.sk">info@triferis.sk</a>
          </li>
          <li>
            <strong>Telefón:</strong>{" "}
            <a href="tel:+421 944 526 240">+421 944 526 240</a>
          </li>
        </ul>
        <p>
          <em>(ďalej len „my“ alebo „prevádzkovateľ“)</em>
        </p>

        <h2>Článok II. Dopyt a cenová ponuka</h2>
        <ul>
          <li>
            Dopyt odoslaný formulárom, e-mailom alebo telefonicky je nezáväzný.
            Jeho odoslaním nevzniká zmluva ani rezervácia.
          </li>
          <li>
            Na dopyt odpovieme spravidla do 24 hodín cenovou ponukou s
            konkrétnym termínom, rozsahom služieb a cenou.
          </li>
          <li>
            Zmluva o ubytovaní vzniká až vtedy, keď ponuku prijmete a my vám
            rezerváciu potvrdíme.
          </li>
          <li>
            Potvrdenú rezerváciu môžete bez poplatku zrušiť najneskôr 7 dní
            pred príchodom, ak sa v ponuke nedohodneme inak. Platobné podmienky
            a podmienky neskoršieho zrušenia uvádzame v ponuke a v potvrdení
            rezervácie.
          </li>
        </ul>

        <h2>Článok III. Ceny a informácie na webe</h2>
        <ul>
          <li>
            Ceny uvedené na webe (napríklad „od 33 € / osoba / noc“) sú
            orientačné. Závisia od termínu, veľkosti skupiny a rozsahu služieb.
            Záväzná je cena uvedená v potvrdenej ponuke.
          </li>
          <li>
            Údaje o kapacite, vybavení areálu a okolí priebežne aktualizujeme.
            Ak nájdete nepresnosť, napíšte nám.
          </li>
          <li>Fotografie na webe majú informatívny charakter.</li>
        </ul>

        <h2>Článok IV. Príchod, odchod a pobyt</h2>
        <ul>
          <li>
            Ubytovať sa dá od 14:00 do 18:00, izby a chatky sa uvoľňujú do
            10:00, ak sa v potvrdení rezervácie nedohodneme inak.
          </li>
          <li>Pobyt trvá najmenej 2 noci, cez Vianoce najmenej 3 noci.</li>
          <li>Domáce zvieratá neprijímame.</li>
        </ul>

        <h2>Článok V. Obsah webu</h2>
        <ul>
          <li>
            Texty, fotografie a logo na webe sú chránené autorským právom. Bez
            nášho súhlasu ich nemožno preberať na komerčné účely.
          </li>
          <li>
            Web obsahuje odkazy na stránky tretích strán. Za ich obsah
            nezodpovedáme.
          </li>
        </ul>

        <h2>Článok VI. Sťažnosti, reklamácie a riešenie sporov</h2>
        <ul>
          <li>
            Sťažnosť alebo reklamáciu našich služieb pošlite e-mailom na{" "}
            <a href="mailto:info@triferis.sk">info@triferis.sk</a> alebo písomne
            na adresu sídla. Vybavíme ju bez zbytočného odkladu, najneskôr do
            30 dní od doručenia.
          </li>
          <li>
            Ak ste spotrebiteľ a s vybavením reklamácie nie ste spokojní, máte
            právo podať návrh na alternatívne riešenie sporu podľa zákona č.
            391/2015 Z. z. Príslušným subjektom je Slovenská obchodná inšpekcia
            (
            <a href="https://www.soi.sk" target="_blank" rel="noopener noreferrer">
              www.soi.sk
            </a>
            ) alebo iný subjekt zo zoznamu vedeného Ministerstvom hospodárstva
            SR.
          </li>
          <li>Orgánom dozoru je Slovenská obchodná inšpekcia.</li>
        </ul>

        <h2>Článok VII. Ochrana osobných údajov</h2>
        <p>
          Ako spracúvame údaje z dopytov a z návštevy webu, opisujú dokumenty{" "}
          <Link to="/ochrana-osobnych-udajov">Ochrana osobných údajov</Link> a{" "}
          <Link to="/cookie-politika">Cookies</Link>.
        </p>

        <h2>Článok VIII. Záverečné ustanovenia</h2>
        <ul>
          <li>
            Tieto podmienky sú účinné od <strong>11. 10. 2026</strong>.
          </li>
          <li>
            Podmienky môžeme zmeniť. Aktuálne znenie je vždy zverejnené na webe
            triferis.sk.
          </li>
          <li>
            Vzťahy, ktoré tieto podmienky neupravujú, sa riadia právnym
            poriadkom Slovenskej republiky, najmä Občianskym zákonníkom a
            predpismi na ochranu spotrebiteľa.
          </li>
        </ul>
      </article>
    </div>
  );
};

export default TermsAndConditions;
